import { render } from "./Server.vue?vue&type=template&id=c7bddef8"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/pages/Popup/Server.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7bddef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7bddef8', __exports__)) {
    api.reload('c7bddef8', __exports__)
  }
  
  module.hot.accept("./Server.vue?vue&type=template&id=c7bddef8", () => {
    api.rerender('c7bddef8', render)
  })

}


export default __exports__